module.exports = __webpack_public_path__ + "img/vouchers10.aabee404.png";